module.exports = __webpack_public_path__ + "prod/1.42.2/img/haoshihuabang-icon.e177fc28.png";